// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The brand panel and the form share one centred card, so the two halves
 * sit side by side instead of being pinned to opposite viewport edges.
 */
.authSplitRoot {
  min-height: 100vh;
  /* Mobile Safari's toolbar makes 100vh taller than the visible area. */
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: var(--space-12) var(--space-6);
  background-color: var(--surface-brand-wash);
  background-image: radial-gradient(
    90% 70% at 50% 0%,
    var(--surface-selected-soft) 0%,
    var(--surface-brand-wash) 60%
  );
  font-family: var(--font);
}

.authSplitCard {
  width: 100%;
  max-width: 1080px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: var(--bg);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.authSplitBrand {
  position: relative;
  padding: var(--space-16) var(--space-12);
  background-color: var(--primary);
  background-image: radial-gradient(
    120% 140% at 8% 0%,
    var(--primary-light) 0%,
    var(--primary) 46%,
    var(--primary-dark) 100%
  );
  color: var(--text-on-primary);
}

/* The signup form runs long; keep the brand copy in view while it scrolls. */
.authSplitBrandInner {
  position: sticky;
  top: var(--space-16);
}

.authSplitLogo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: inherit;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.0625rem;
  letter-spacing: -0.018em;
}

.authSplitKicker {
  margin: var(--space-12) 0 var(--space-2);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.82);
}

.authSplitHeadline {
  /* siteShell sets a dark colour on every h1; the panel is plum. */
  color: inherit;
  margin: 0 0 var(--space-3);
  font-size: clamp(1.6rem, 1.28rem + 1.05vw, 2.15rem);
  line-height: 1.13;
  letter-spacing: -0.024em;
  font-weight: 700;
  max-width: 22ch;
}

.authSplitBody {
  margin: 0;
  max-width: 42ch;
  line-height: 1.55;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
}

.authSplitArt {
  margin-top: var(--space-8);
  width: 100%;
  aspect-ratio: 4 / 3;
  max-height: min(280px, 36vh);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.authSplitArt img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.authSplitForm {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-12);
  background: var(--bg);
}

.authSplitForm > * {
  width: 100%;
  max-width: 420px;
}

@media (max-width: 900px) {
  .authSplitRoot {
    place-items: start center;
    padding: var(--space-6) var(--space-4);
  }
  .authSplitCard {
    max-width: 560px;
    grid-template-columns: 1fr;
  }
  .authSplitBrand {
    padding: var(--space-6) var(--space-6) var(--space-5);
  }
  .authSplitBrandInner {
    position: static;
  }
  .authSplitKicker {
    margin-top: var(--space-6);
  }
  .authSplitArt {
    display: none;
  }
  .authSplitForm {
    padding: var(--space-8) var(--space-6);
  }
}

@media (max-width: 480px) {
  .authSplitRoot {
    padding: 0;
  }
  .authSplitCard {
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .authSplitForm {
    padding: var(--space-5) var(--gutter) var(--space-8);
  }

  /* A slim brand strip so the form starts above the fold. */
  .authSplitBrand {
    padding: var(--space-4) var(--gutter) var(--space-5);
  }

  .authSplitKicker {
    margin: var(--space-4) 0 var(--space-1);
  }

  .authSplitHeadline {
    margin: 0;
    font-size: 1.2rem;
    line-height: 1.25;
  }

  .authSplitBody {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layouts/authSplitLayout.css"],"names":[],"mappings":"AAEA;;;EAGE;AACF;EACE,iBAAiB;EACjB,sEAAsE;EACtE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;EAC3C;;;;GAIC;EACD,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uDAAuD;EACvD,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC;;;;;GAKC;EACD,6BAA6B;AAC/B;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iEAAiE;EACjE,cAAc;EACd,0BAA0B;EAC1B,mDAAmD;EACnD,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;IACzB,sCAAsC;EACxC;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,qDAAqD;EACvD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,oDAAoD;EACtD;;EAEA,0DAA0D;EAC1D;IACE,oDAAoD;EACtD;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"../../colors.css\");\n\n/*\n * The brand panel and the form share one centred card, so the two halves\n * sit side by side instead of being pinned to opposite viewport edges.\n */\n.authSplitRoot {\n  min-height: 100vh;\n  /* Mobile Safari's toolbar makes 100vh taller than the visible area. */\n  min-height: 100dvh;\n  display: grid;\n  place-items: center;\n  padding: var(--space-12) var(--space-6);\n  background-color: var(--surface-brand-wash);\n  background-image: radial-gradient(\n    90% 70% at 50% 0%,\n    var(--surface-selected-soft) 0%,\n    var(--surface-brand-wash) 60%\n  );\n  font-family: var(--font);\n}\n\n.authSplitCard {\n  width: 100%;\n  max-width: 1080px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  background: var(--bg);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.authSplitBrand {\n  position: relative;\n  padding: var(--space-16) var(--space-12);\n  background-color: var(--primary);\n  background-image: radial-gradient(\n    120% 140% at 8% 0%,\n    var(--primary-light) 0%,\n    var(--primary) 46%,\n    var(--primary-dark) 100%\n  );\n  color: var(--text-on-primary);\n}\n\n/* The signup form runs long; keep the brand copy in view while it scrolls. */\n.authSplitBrandInner {\n  position: sticky;\n  top: var(--space-16);\n}\n\n.authSplitLogo {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  color: inherit;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 1.0625rem;\n  letter-spacing: -0.018em;\n}\n\n.authSplitKicker {\n  margin: var(--space-12) 0 var(--space-2);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.authSplitHeadline {\n  /* siteShell sets a dark colour on every h1; the panel is plum. */\n  color: inherit;\n  margin: 0 0 var(--space-3);\n  font-size: clamp(1.6rem, 1.28rem + 1.05vw, 2.15rem);\n  line-height: 1.13;\n  letter-spacing: -0.024em;\n  font-weight: 700;\n  max-width: 22ch;\n}\n\n.authSplitBody {\n  margin: 0;\n  max-width: 42ch;\n  line-height: 1.55;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.authSplitArt {\n  margin-top: var(--space-8);\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  max-height: min(280px, 36vh);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.22);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.authSplitArt img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.authSplitForm {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-16) var(--space-12);\n  background: var(--bg);\n}\n\n.authSplitForm > * {\n  width: 100%;\n  max-width: 420px;\n}\n\n@media (max-width: 900px) {\n  .authSplitRoot {\n    place-items: start center;\n    padding: var(--space-6) var(--space-4);\n  }\n  .authSplitCard {\n    max-width: 560px;\n    grid-template-columns: 1fr;\n  }\n  .authSplitBrand {\n    padding: var(--space-6) var(--space-6) var(--space-5);\n  }\n  .authSplitBrandInner {\n    position: static;\n  }\n  .authSplitKicker {\n    margin-top: var(--space-6);\n  }\n  .authSplitArt {\n    display: none;\n  }\n  .authSplitForm {\n    padding: var(--space-8) var(--space-6);\n  }\n}\n\n@media (max-width: 480px) {\n  .authSplitRoot {\n    padding: 0;\n  }\n  .authSplitCard {\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n  .authSplitForm {\n    padding: var(--space-5) var(--gutter) var(--space-8);\n  }\n\n  /* A slim brand strip so the form starts above the fold. */\n  .authSplitBrand {\n    padding: var(--space-4) var(--gutter) var(--space-5);\n  }\n\n  .authSplitKicker {\n    margin: var(--space-4) 0 var(--space-1);\n  }\n\n  .authSplitHeadline {\n    margin: 0;\n    font-size: 1.2rem;\n    line-height: 1.25;\n  }\n\n  .authSplitBody {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
